export function isArray(obj) {
  // only implement if no native implementation is available
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };
  return Array.isArray(obj);
}
